import { PropsWithChildren } from 'react'

export function Title({ children }: PropsWithChildren) {
  return (
    <h2 className='font-body text-2xl sm:text-xl font-medium tracking-normal'>
      {children}
    </h2>
  )
}
